export var MIN_WAGER_VALUE = Number(process.env.REACT_MIN_WAGER_VALUE);
export var MAX_WAGER_VALUE = Number(process.env.REACT_MAX_WAGER_VALUE);
export var MIN_WAGER_PER_BET_LINE_VALUE = Number(process.env.REACT_MIN_WAGER_PER_BET_LINE_VALUE);
